import script from "./EstimateDocumentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateDocumentEditor.vue?vue&type=script&setup=true&lang=js"

import "./EstimateDocumentEditor.vue?vue&type=style&index=0&id=d1b54e06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1b54e06"]])

export default __exports__